import { Dispatch, Reducer } from "react";

import AssetManager from "../../common/AssetManager";
import createDataContext from "../createDataContext";
import {
  FindWikisAction,
  LoadWikisAction,
  Wiki,
  WikiActionType,
  WikiActions,
  WikiState,
} from "./types";

const wikiReducer: Reducer<WikiState, WikiActions> = (
  state: WikiState,
  action: WikiActions
) => {
  switch (action.type) {
    case WikiActionType.LOAD_WIKIS: {
      return {
        ...state,
        wikis: [...action.payload.wikis],
      };
    }
    case WikiActionType.FIND_WIKIS: {
      return {
        ...state,
        listedWikis: [...action.payload.wikis],
      };
    }
    default:
      return state;
  }
};

const loadWikis = (dispatch: Dispatch<LoadWikisAction>) => () => {
  const wikis: Wiki[] = AssetManager.getAsset("/wiki_db.json")[
    "wikis"
  ] as Wiki[];

  dispatch({
    type: WikiActionType.LOAD_WIKIS,
    payload: {
      wikis: wikis,
    },
  });
};

const findWikis =
  (dispatch: Dispatch<FindWikisAction>, state: WikiState) =>
  (wikiIDList: number[]) => {
    const wikis = wikiIDList
      .map((id) => state.wikis.find((wiki) => wiki.wikiID === id)!)
      .filter((wiki) => wiki !== undefined);

    const uniqueWikis: Wiki[] = Array.from(
      new Set(wikis.map((wiki) => wiki.wikiID))
    ).map((id) => wikis.find((wiki) => wiki.wikiID === id)!);

    dispatch({
      type: WikiActionType.FIND_WIKIS,
      payload: {
        wikis: uniqueWikis,
      },
    });
  };

export const { Context, Provider } = createDataContext(
  wikiReducer,
  { loadWikis, findWikis },
  new WikiState()
);
